import styled from 'styled-components';

export const FormField = styled.div`
  position: relative;
`;

export const ErrorMessage = styled.span`
  position: absolute;
  left: 16px;
  bottom: 0px;
  font-size: 0.75rem;
  color: var(--red-status-color);
`;
